// removed by extract-text-webpack-plugin
module.exports = {"contact":"src-pages-projects----styles-module---contact---QSqcA"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/styles.module.css
// module id = ./src/pages/projects/styles.module.css
// module chunks = 102538987983895